import { apiFetch } from '../../config/api';

/**
 * Tenant Service
 * Handles tenant-related API operations
 */
export const tenantService = {
  /**
   * Load all tenants with pagination
   */
  async loadTenants(page = 1, pageSize = 10) {
    try {
      const response = await apiFetch(
        `/api/v1/tenant/list?page=${page}&page_size=${pageSize}`
      );
      return {
        tenants: response.tenants || [],
        pagination: {
          page: response.page || page,
          pageSize: response.page_size || pageSize,
          total: response.total || 0,
        },
      };
    } catch (error) {
      // Handle the specific 500 error from tenant list endpoint
      if (error.message.includes('HTTP 500')) {
        // Tenant list endpoint has validation issues
        // Return empty state instead of throwing error
        return {
          tenants: [],
          pagination: {
            page: 1,
            pageSize: 10,
            total: 0,
          },
          error:
            'Tenant list endpoint is temporarily unavailable due to server validation issues.',
        };
      }
      throw error;
    }
  },
};
